import React, { useState, useContext } from "react";
import {
  useParams,
} from "react-router-dom";
import { FaCalendarAlt, FaAddressCard, FaComment } from "react-icons/fa";
import { MdCheckCircle } from "react-icons/md";
import { SiSpinrilla } from "react-icons/si";
import ReCAPTCHA from "react-google-recaptcha";
import { addDoc, collection, Timestamp } from "firebase/firestore";
import toast, { Toaster } from 'react-hot-toast';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import '../components/Calendar/Calendar.css';
import {FirebaseContext} from '../services/Firebase/Context';
import MiddleLayout from '../layouts/MiddleLayout'

const PublicAppointment = () => {
  const activeDate = new Date()
  if(activeDate.getDay(5) || activeDate.getDay(6)) {
    activeDate.setDate(activeDate.getDate() + 4);
  } else {
    activeDate.setDate(activeDate.getDate() + 2);
  }

  const { id } = useParams();
  const { db } = useContext(FirebaseContext);
  const [step, setStep] = useState(0)
  const [date, setDate] = useState(activeDate);
  const [tel, setTel] = useState();
  const [name, setName] = useState();
  const [comments, setComments] = useState();
  const [isBusiness, setIsBusiness] = useState(false);
  const [captcha, setCaptcha] = useState(false);
  const [loading, setLoading] = useState(false);

  const next = () => {
    const nextStep = step + 1
    if(nextStep >= 4) return
    setStep(step + 1)
  }

  const back = () => {
    const backStep = step - 1
    if(backStep < 0) return
    setStep(step - 1)
  }

  const tileDisabled = ({ date }) => {
    return date.getDay() === 0 || date.getDay() === 6
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    if( !date || !tel || !name || !comments || !captcha) {
      toast.error('Tous les champs sont obligatoires. Veuillez les renseigner');
      return
    }
    setLoading(true)
    const appointment = {
      date: Timestamp.fromDate(date),
      createdAt: Timestamp.now(),
      phone: tel,
      name,
      comments,
      isBusiness,
      status: 'new',
      organisationId: id,
    }
    addDoc(collection(db, "appointments"), appointment)
    .then(() => {
      next()
      setLoading(false)
    })
    .catch((err) => {
      setLoading(false)
      toast.error('Erreur veuillez reessayer');
    });
  }

  const renderStep = () => {
    switch (step) {
      case 0:
        return <div>
          <Calendar
            onChange={setDate}
            value={date}
            minDate={activeDate}
            tileDisabled={tileDisabled}
          />
        </div>
      case 1:
        return <>
          <input
            type="text"
            value={name}
            className="rounded-lg border-transparent flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
            placeholder="Laissez votre nom"
            onChange={(e) => setName(e.target.value)}
          />
          <input
            type="tel"
            value={tel}
            className="mt-5 rounded-lg border-transparent flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
            placeholder="Laissez votre n° de téléphone"
            onChange={(e) => setTel(e.target.value)}
          />
          <label className="flex items-center mt-5">
            <input
              type="checkbox"
              checked={isBusiness}
              className="h-6 w-6"
              onChange={(e) => setIsBusiness(e.target.checked)}
            />
            <span className="ml-2">Je suis un professionnel</span>
          </label>
        </>
      case 2:
        return <>
          <textarea
            className="flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 rounded-lg text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
            placeholder="De quoi avez-vous besoin ?"
            rows="5"
            cols="40"
            value={comments}
            onChange={(e) => setComments(e.target.value)}
          />
          <ReCAPTCHA
            sitekey="6Ldk-M8SAAAAAIRbvuR0BXnYego8MNcueox9jLRv"
            onChange={(value) => {
              setCaptcha(true)
            }}
          />
        </>
      case 3:
        return <p className="text-center">
          <MdCheckCircle className='text-green-500 w-full mb-5' size={50} />
          Merci pour votre demande !
          <br/>
          Nous vous confirmerons votre rendez-vous dès que possible.
        </p>
      default:
        return null
    }
  }

  return (
    <MiddleLayout bgImage dark>
        <div className="p-5 bg-gray-100 rounded">
          <div className="mx-4 p-4">
            <div className="flex items-center">
              <div className="flex items-center relative">
                <div
                  className={`
                    rounded-full
                    transition
                    duration-500
                    ease-in-out
                    h-12
                    w-12
                    py-3
                    ${step === 0 ? 'bg-blue-500' : '' }
                    ${step === 0 ? 'text-white' : (step > 0 ? 'text-blue-500' : '') }
                    border-2 border-blue-500
                    justify-center
                    flex
                    `}
                >
                  <FaCalendarAlt />
                </div>
                <div
                  className={`
                    absolute
                    top-0
                    -ml-10
                    text-center
                    mt-16
                    w-32
                    text-xs
                    font-medium
                    uppercase
                    ${step >= 0 ? 'text-blue-500' : '' }
                  `}
                >
                  Date
                </div>
              </div>
              <div
                className={`
                  flex-auto
                  border-t-2
                  transition
                  duration-500
                  ease-in-out
                  ${step > 0 ? 'border-blue-500' : 'border-gray-300' }
                `}
              ></div>
              <div className="flex items-center relative">
                <div
                  className={`
                    rounded-full
                    transition
                    duration-500
                    ease-in-out
                    h-12
                    w-12
                    py-3
                    border-2
                    ${step === 1 ? 'bg-blue-500' : '' }
                    ${step === 1 ? 'text-white' : (step > 1 ? 'text-blue-500' : 'text-gray-500') }
                    ${step >= 1 ? 'border-blue-500' : 'border-gray-300' }
                    justify-center
                    flex
                  `}
                >
                  <FaAddressCard size={20} />
                </div>
                <div
                  className={`
                    absolute
                    top-0
                    -ml-10
                    text-center
                    mt-16
                    w-32
                    text-xs
                    font-medium
                    uppercase
                    ${step >= 1 ? 'text-blue-500' : 'text-gray-500' }
                  `}
                >
                  Coordonnées
                </div>
              </div>
              <div
                className={`
                  flex-auto
                  border-t-2
                  transition
                  duration-500
                  ease-in-out
                  ${step > 1 ? 'border-blue-500' : 'border-gray-300' }
                `}
              ></div>
              <div className="flex items-center relative">
                <div
                  className={`
                    rounded-full
                    transition
                    duration-500
                    ease-in-out
                    h-12
                    w-12
                    py-3
                    ${step === 2 ? 'bg-blue-500' : '' }
                    ${step === 2 ? 'text-white' : (step > 1 ? 'text-blue-500' : 'text-gray-500') }
                    ${step >= 2 ? 'border-blue-500' : 'border-gray-300' }
                    border-2
                    justify-center
                    flex
                  `}
                >
                  <FaComment size={20} />
                </div>
                <div
                  className={`
                    absolute
                    top-0
                    -ml-10
                    text-center
                    mt-16
                    w-32
                    text-xs
                    font-medium
                    uppercase
                    ${step >= 2 ? 'text-blue-500' : 'text-gray-500' }
                  `}
                >
                  Message
                </div>
              </div>
            </div>
          </div>
          <div className="mt-8 p-4">
            <div className='max-w-xs'>
              {renderStep()}
            </div>
            <div className="flex p-2 mt-4">
              <button
                className={`
                  ${ step === 3 || step === 0 ? 'hidden' : ''}
                  bg-gray-200
                  text-gray-800
                  active:bg-purple-600
                  font-bold
                  uppercase
                  text-sm
                  px-6
                  py-3
                  rounded
                  shadow
                  hover:shadow-lg
                  outline-none
                  focus:outline-none
                  mr-1
                  mb-1
                  ease-linear
                  transition-all
                  duration-150
                  disabled
                `}
                type="button"
                onClick={back}
              >
                Retour
              </button>
              <div className="flex-auto flex flex-row-reverse">
                <button
                  className={`
                    mx-3
                    ${ step === 3 ? 'hidden' : ''}
                    ${ step === 2 ? 'bg-green-500' : 'bg-blue-500'}
                    text-white
                    active:${ step === 2 ? 'bg-green-600' : 'bg-blue-600'}
                    font-bold
                    uppercase
                    text-sm
                    px-6
                    py-3
                    rounded
                    shadow
                    hover:shadow-lg
                    outline-none
                    focus:outline-none
                    mr-1
                    mb-1
                    ease-linear
                    transition-all
                    duration-150
                  `}
                  type="button"
                  onClick={step === 2 ? handleSubmit : next}
                >
                  {
                    loading
                    ? <>
                      <SiSpinrilla size={18} className="mr-2 animate-spin"/>
                      </>
                    : (
                      step === 2
                        ? 'Envoyer'
                        : 'Suivant'
                    )
                  }
                </button>
                
              </div>
            </div>
          </div>
          <Toaster />
        </div>
    </MiddleLayout>
  );
}

export default PublicAppointment
